// extracted by mini-css-extract-plugin
export default {"shapeWrap":"_3HofyA"};